import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { App, AutoComplete, Form, Select, } from 'antd';
import { txt } from 'libs/i18n';
import { filterOption } from 'libs/filterOption';
import SelectWithActions from 'components/SelectWithActions';
import { useSession } from 'components/Authenticated';
import { fetchSpeakerRoleValues } from 'api/speaker-api';
const Role = ({ onClose, multiple = false, options = [], onAdd, onEdit, onDelete, autoFocus = false, openAddModal, }) => {
    const [suggestedRoles, setSuggestedRoles] = useState({
        isSelectionStrict: false,
        data: [],
    });
    const { session } = useSession();
    const { message } = App.useApp();
    const { teamSettings } = session;
    useEffect(() => {
        const fetchRoles = async () => {
            const isSelectionStrict = teamSettings.isStrictRoleSelection;
            const result = await fetchSpeakerRoleValues(session.connection);
            if (result.isSuccess()) {
                setSuggestedRoles({ data: result.get(), isSelectionStrict });
            }
            else {
                void message.error(txt('failedToFetchRole'), 2);
            }
        };
        void fetchRoles();
    }, []);
    const suggestedOptions = useMemo(() => suggestedRoles.data.map((item) => ({
        key: item,
        value: item,
        label: item,
    })), [suggestedRoles]);
    return multiple ? (_jsx(SelectWithActions, { fieldName: "role", label: txt('role'), addLabel: txt('addRole'), editLabel: txt('editRole'), options: options, onAdd: onAdd, onEdit: onEdit, onDelete: onDelete, allowStar: true, storeFullItem: true, autoFocus: autoFocus, autoOpenAddModal: openAddModal, suggestedOptions: suggestedOptions, isSelectionStrict: suggestedRoles.isSelectionStrict, onClose: onClose })) : (_jsx(Form.Item, { name: "role", label: txt('role'), getValueProps: (value) => { var _a; return ({ value: (_a = value === null || value === void 0 ? void 0 : value.label) !== null && _a !== void 0 ? _a : '' }); }, getValueFromEvent: (value) => ({
            label: value,
            isDefault: true,
        }), rules: [
            () => ({
                required: suggestedRoles.isSelectionStrict,
                validator(_, value) {
                    if (suggestedRoles.isSelectionStrict) {
                        if (!suggestedRoles.data.includes(value.label.trim())) {
                            return Promise.reject(txt('chooseRole'));
                        }
                    }
                    return Promise.resolve();
                },
            }),
        ], children: suggestedRoles.isSelectionStrict ? (_jsx(Select, { showSearch: true, filterOption: filterOption, options: suggestedOptions, autoFocus: autoFocus })) : (_jsx(AutoComplete, { placeholder: txt('roleExample'), filterOption: filterOption, options: suggestedOptions, autoFocus: autoFocus })) }));
};
export default Role;
